// extracted by mini-css-extract-plugin
module.exports = {"root":"Spinner_root__2DFTQ","rotate":"Spinner_rotate__1dsHj","circle":"Spinner_circle__1uQMR","dash":"Spinner_dash__3S7Nj","white":"Spinner_white__2m5IA"};